import { render } from "./prescriptionUsage.vue?vue&type=template&id=e3fc9366&scoped=true"
import script from "./prescriptionUsage.vue?vue&type=script&lang=js"
export * from "./prescriptionUsage.vue?vue&type=script&lang=js"

import "./prescriptionUsage.vue?vue&type=style&index=0&id=e3fc9366&lang=scss&scoped=true"

import exportComponent from "/Users/wlxqxxf/铭方营养/nutrition-web-wechat/node_modules/_vue-loader@16.8.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3fc9366"]])

export default __exports__